import React from 'react';
import type { SVGProps } from 'react';

const IconPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}>
    <path stroke="currentColor" strokeWidth="2" d="M0 7.881h16M8 16.5V.5" />
  </svg>
);

export default IconPlus;
